import { Box, styled } from "@mui/material";

export const BoxGapInput = styled(Box)(({ theme }) => ({
  display: "grid",
  rowGap: "16px",
  padding: "16px",
}));
